// Routes ///////////////////////////////////////////////////////////////
export const DashboardRoute = (): string => `/dashboard`;
export const DashboardChartRoute = (chartId, ids, switchTitle?): string =>
  `/dashboard/chart/?chartId=${chartId}&ids=${ids}${
    switchTitle ? `&switchTitle=${switchTitle}` : ''
  }`;
export const MarketSummaryRoute = (id): string =>
  `/dashboard/market-summary/?id=${id}`;
export const ImpactIndicatorsRoute = (): string =>
  `/dashboard/impact-indicators/`;
export const SupervisorMessagesRoute = (): string =>
  `/dashboard/supervisor-messages`;

// Socket //////////////////////////////////////////////////////////////////
export const DashboardSocket = (): string => '/ws/v1/dashboard/';
export const DashboardExtensionSocket = (): string =>
  '/ws/v1/dashboard/extension/';

// API //////////////////////////////////////////////////////////////////
export const DashboardMarketIndicesUrl = (): string =>
  `/api/v1/dashboard/market_indices/`;
